import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    initLocationAddSurveyObj,
    locationAddSurveyTypeList,
    initPageObj,
    initCoverObj,
} from "../data/type";

//Sliceの作成
export const locationAddSurveySlice = createSlice({
    name: "obj",
    initialState: {
        obj: initLocationAddSurveyObj,
        pageObj: initPageObj,
        objcover: initCoverObj,
    },

    reducers: {
        setAddSurveyObj: (state, action) => {
            state.obj = action.payload;
        },
        setAddSurveyDocPdfPath: (state, action) => {
            //追加調査ページ
            state.obj.doc_pdf_path = action.payload; //追加調査_説明資料_pdfパス
        },
        setAddSurveyPageObj: (state, action) => {
            state.pageObj = action.payload;
        },
        setObjCover: (state, action) => {
            state.objcover = action.payload;
        },
        setAddSurveryUpdateIsExcluded: (state, action: PayloadAction<{ index: number, labelName: keyof locationAddSurveyTypeList, isExcluded: boolean}>) => {
            const { index, labelName, isExcluded } = action.payload;
            const documentArray = state.obj[labelName];
            if (documentArray && documentArray[index]) {
                documentArray[index].isExcluded = isExcluded;
            }
        }
    },
});

export const {
    setAddSurveyObj,
    setAddSurveyDocPdfPath,
    setAddSurveyPageObj,
    setObjCover,
    setAddSurveryUpdateIsExcluded
} = locationAddSurveySlice.actions;
export default locationAddSurveySlice.reducer;
